/* Element Kin reading page controller. Needs window.EKLunar and window.EKReading. */
;(function () {
  "use strict"

  var root = document.querySelector("[data-ek-reading]")
  if (!root) return

  var ELEMENT = {
    wood: { title: "Wood", zh: "木", color: "#3E7C59", word: "growth and renewal" },
    fire: { title: "Fire", zh: "火", color: "#C0392B", word: "warmth and expression" },
    earth: { title: "Earth", zh: "土", color: "#C8A15A", word: "stability and nourishment" },
    metal: { title: "Metal", zh: "金", color: "#8F9AA8", word: "clarity and resolve" },
    water: { title: "Water", zh: "水", color: "#22456E", word: "wisdom and calm" },
  }
  var LEVEL_LABEL = { missing: "Missing", low: "Low", balanced: "Balanced", strong: "Strong" }
  var ZODIAC_EN = {
    鼠: "Rat", 牛: "Ox", 虎: "Tiger", 兔: "Rabbit", 龙: "Dragon", 蛇: "Snake",
    马: "Horse", 羊: "Goat", 猴: "Monkey", 鸡: "Rooster", 狗: "Dog", 猪: "Pig",
  }
  var TRAD = { 龙: "龍", 马: "馬", 鸡: "雞", 猪: "豬" }
  var PILLAR_LABEL = { year: "Year", month: "Month", day: "Day", hour: "Hour" }

  var catalog = {}
  try {
    catalog = JSON.parse(document.getElementById("EkCatalog").textContent)
  } catch (e) {
    catalog = {}
  }

  var form = root.querySelector("[data-ek-form]")
  var errorEl = root.querySelector("[data-ek-error]")
  var formStep = root.querySelector('[data-step="form"]')
  var resultStep = root.querySelector('[data-step="result"]')
  var discount = root.getAttribute("data-discount") || ""

  function $(sel) {
    return root.querySelector(sel)
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
    })
  }
  function trad(s) {
    return String(s).replace(/[龙马鸡猪]/g, function (c) { return TRAD[c] })
  }

  // Populate year and hour selects.
  ;(function fillSelects() {
    var years = root.querySelector("[data-ek-years]")
    var now = new Date().getFullYear()
    var html = '<option value="">Year</option>'
    for (var y = now; y >= 1930; y--) html += '<option value="' + y + '">' + y + "</option>"
    years.innerHTML = html
    var hours = root.querySelector("[data-ek-hours]")
    window.EKReading.HOUR_WINDOWS.forEach(function (w) {
      var o = document.createElement("option")
      o.value = String(w.hour)
      o.textContent = w.label
      hours.appendChild(o)
    })
  })()

  function showError(msg) {
    errorEl.textContent = msg
    errorEl.hidden = !msg
  }

  function validDate(y, m, d) {
    var dt = new Date(y, m - 1, d)
    return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d && dt <= new Date()
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault()
    showError("")
    var fd = new FormData(form)
    var y = Number(fd.get("year"))
    var m = Number(fd.get("month"))
    var d = Number(fd.get("day"))
    if (!y || !m || !d) return showError("Please choose your full birth date.")
    if (!validDate(y, m, d)) return showError("That date doesn't look right. Please check the day and month.")
    var email = String(fd.get("email") || "").trim()
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return showError("Please check your email address.")

    if (!window.EKLunar || !window.EKReading) {
      return showError("The reading is still loading. Please try again in a moment.")
    }
    var hour = fd.get("hour")
    var chart = window.EKReading.readChart(window.EKLunar.Solar, {
      year: y, month: m, day: d, hour: hour === "" ? null : Number(hour),
    })
    var name = String(fd.get("name") || "").trim().slice(0, 40)

    if (email && fd.get("consent")) subscribe(email, name, chart)
    track("ek_reading_complete", { element: chart.recommendation.element, has_hour: chart.hasHour })

    renderResult(chart, name, { y: y, m: m, d: d })
    formStep.hidden = true
    resultStep.hidden = false
    resultStep.focus({ preventScroll: true })
    window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 20, behavior: "smooth" })
    try {
      sessionStorage.setItem("ek_element", chart.recommendation.element)
    } catch (err) {
      /* storage may be unavailable */
    }
  })

  root.querySelector("[data-ek-restart]").addEventListener("click", function () {
    resultStep.hidden = true
    formStep.hidden = false
    form.reset()
    window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 20, behavior: "smooth" })
  })

  function renderResult(chart, name, date) {
    var rec = chart.recommendation
    var el = ELEMENT[rec.element]
    var dm = ELEMENT[chart.dayMaster]
    var dateStr = new Date(date.y, date.m - 1, date.d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
    var zodiac = ZODIAC_EN[chart.zodiac] || ""

    $("[data-ek-result-eyebrow]").textContent =
      "Your Elemental Profile" + (name ? " · " + name : "") + " · born " + dateStr
    $("[data-ek-result-title]").innerHTML =
      "Your Day Master is <span style=\"color:" + dm.color + '">' + dm.title +
      ' <span lang="zh-Hant">' + dm.zh + "</span></span>"

    var why = {
      missing: "Your chart has no " + el.title + " at all. In Five Elements tradition, the missing element is the one to bring in.",
      "support-day-master": "Your " + dm.title + " Day Master needs support. " + el.title + " is the element that feeds " + dm.title + " in the generating cycle.",
      "drain-day-master": "Your " + dm.title + " Day Master is very strong. " + el.title + " gently channels that energy outward, bringing the chart into balance.",
      weakest: el.title + " is the quietest element in your chart. Wearing it is a way to round out your balance.",
    }[rec.reason]
    $("[data-ek-result-summary]").innerHTML =
      "Your element to wear is <strong style=\"color:" + el.color + '">' + el.title + ' <span lang="zh-Hant">' + el.zh +
      "</span></strong>, the element of " + el.word + ". " + esc(why) +
      (zodiac ? " Your zodiac animal is the " + zodiac + ' <span lang="zh-Hant">' + trad(chart.zodiac) + "</span>." : "")

    renderChart(chart)
    renderPillars(chart)
    renderRecommendations(rec.element)

    var codeEl = $("[data-ek-code]")
    if (discount) {
      codeEl.hidden = false
      codeEl.innerHTML = 'Code <strong>' + esc(discount) + "</strong> applied at checkout"
    }
  }

  function renderChart(chart) {
    var lv = chart.recommendation.levels
    var max = Math.max.apply(null, window.EKReading.ELEMENTS.map(function (k) { return chart.percent[k] })) || 1
    var html = window.EKReading.ELEMENTS.map(function (k) {
      var e = ELEMENT[k]
      var pct = chart.percent[k]
      var tag = k === chart.dayMaster ? "Your Day Master" : LEVEL_LABEL[lv[k]]
      var isRec = k === chart.recommendation.element
      return (
        '<div class="ek-bar' + (isRec ? " is-rec" : "") + '">' +
        '<span class="ek-bar__label"><span lang="zh-Hant">' + e.zh + "</span> " + e.title + "</span>" +
        '<span class="ek-bar__track"><span class="ek-bar__fill" style="--w:' + Math.max(2, (pct / max) * 100) + "%;--c:" + e.color + '"></span></span>' +
        '<span class="ek-bar__pct">' + pct + "%</span>" +
        '<span class="ek-bar__tag ek-bar__tag--' + (k === chart.dayMaster ? "master" : lv[k]) + '">' + tag + "</span>" +
        "</div>"
      )
    }).join("")
    $("[data-ek-chart]").innerHTML = html
  }

  function renderPillars(chart) {
    var STEM_EL = { 甲: "wood", 乙: "wood", 丙: "fire", 丁: "fire", 戊: "earth", 己: "earth", 庚: "metal", 辛: "metal", 壬: "water", 癸: "water" }
    var BRANCH_EL = { 子: "water", 丑: "earth", 寅: "wood", 卯: "wood", 辰: "earth", 巳: "fire", 午: "fire", 未: "earth", 申: "metal", 酉: "metal", 戌: "earth", 亥: "water" }
    $("[data-ek-pillars]").innerHTML = chart.pillars.map(function (p) {
      var s = ELEMENT[STEM_EL[p.stem]]
      var b = ELEMENT[BRANCH_EL[p.branch]]
      return (
        '<div class="ek-pillar' + (p.name === "day" ? " is-day" : "") + '">' +
        '<span class="ek-pillar__name">' + PILLAR_LABEL[p.name] + "</span>" +
        '<span class="ek-pillar__ch" lang="zh-Hant" style="color:' + s.color + '">' + p.stem + "</span>" +
        '<span class="ek-pillar__ch" lang="zh-Hant" style="color:' + b.color + '">' + trad(p.branch) + "</span>" +
        "</div>"
      )
    }).join("")
    $("[data-ek-pillars-note]").textContent = chart.hasHour
      ? "Four Pillars: year, month, day and hour. The day stem is your Day Master."
      : "Three Pillars shown. Add your birth time for the full Four Pillars reading."
  }

  function productCard(p, big) {
    var variants = p.variants.filter(function (v) { return v.available })
    var select = variants.length > 1
      ? '<select class="ek-rec__size" aria-label="Wrist size for ' + esc(p.title) + '">' +
        variants.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + "</option>" }).join("") +
        "</select>"
      : ""
    var media = p.image
      ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">'
      : '<span class="ek-rec__ph" aria-hidden="true"></span>'
    return (
      '<article class="ek-card' + (big ? " ek-card--hero" : "") + '" data-variant="' + (variants[0] ? variants[0].id : "") + '">' +
      '<a class="ek-card__media" href="' + esc(p.url) + '">' + media + "</a>" +
      '<div class="ek-card__body">' +
      '<h4 class="ek-card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + "</a></h4>" +
      '<p class="ek-card__mat">' + esc(p.materials || "") + "</p>" +
      (big && p.meaning ? '<p class="ek-card__meaning">' + esc(p.meaning) + "</p>" : "") +
      '<p class="ek-card__price"><span>' + esc(p.price) + "</span>" + (p.compare ? " <s>" + esc(p.compare) + "</s>" : "") + "</p>" +
      (variants.length
        ? select + '<button type="button" class="ek-btn ' + (big ? "ek-btn--seal" : "ek-btn--ghost") + ' ek-card__add" data-ek-add>Add to cart</button>'
        : '<p class="ek-card__soldout">Sold out</p>') +
      '<p class="ek-card__msg" role="status"></p>' +
      "</div></article>"
    )
  }

  function renderRecommendations(element) {
    var items = (catalog[element] || []).slice()
    var hero = items.filter(function (p) { return p.role === "hero" })[0] || items[0]
    var others = items.filter(function (p) { return p !== hero })
    // Add the Day-Master-friendly companion element's hero as a third pick.
    var feeder = window.EKReading.GENERATED_BY[element]
    var feederHero = (catalog[feeder] || []).filter(function (p) { return p.role === "hero" })[0]
    if (feederHero) others = others.slice(0, 2).concat([feederHero])

    $("[data-ek-hero]").innerHTML = hero ? productCard(hero, true) : "<p>New pieces are on the way.</p>"
    $("[data-ek-more]").innerHTML = others.map(function (p) { return productCard(p, false) }).join("")

    root.querySelectorAll(".ek-card").forEach(function (card) {
      var sel = card.querySelector(".ek-rec__size")
      if (sel) sel.addEventListener("change", function () { card.setAttribute("data-variant", sel.value) })
    })
  }

  // Add to cart through the Ajax Cart API, then go to the cart with the code.
  root.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-ek-add]")
    if (!btn) return
    var card = btn.closest(".ek-card")
    var id = Number(card.getAttribute("data-variant"))
    var msg = card.querySelector(".ek-card__msg")
    btn.disabled = true
    btn.textContent = "Adding…"
    var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"
    fetch(root_ + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _ek_reading: sessionStorage.getItem("ek_element") || "" } }] }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || "Could not add to cart") })
        return r.json()
      })
      .then(function () {
        track("ek_add_to_cart", { variant: id })
        btn.textContent = "Added ✓"
        msg.innerHTML = '<a href="' + root_ + (discount ? "discount/" + encodeURIComponent(discount) + "?redirect=/cart" : "cart") + '">View cart' + (discount ? " with your code" : "") + " →</a>"
        document.dispatchEvent(new CustomEvent("ek:cart-updated"))
      })
      .catch(function (err) {
        btn.disabled = false
        btn.textContent = "Add to cart"
        msg.textContent = err.message
      })
  })

  // Optional newsletter signup through Shopify's customer form.
  function subscribe(email, name, chart) {
    var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"
    var body = new URLSearchParams()
    body.set("form_type", "customer")
    body.set("utf8", "✓")
    body.set("contact[email]", email)
    body.set("contact[tags]", "newsletter,ek-reading,element-" + chart.recommendation.element)
    if (name) body.set("contact[first_name]", name)
    fetch(root_ + "contact#contact_form", { method: "POST", body: body, credentials: "same-origin" }).catch(function () {})
  }

  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, data)
      }
    } catch (e) {
      /* analytics must never break the page */
    }
  }
})()
